import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { Stack } from '@/common/components/Stack/Stack';
import { SimulateFamilyMemberCard } from '@/common/containers/Dashboard/Insurance/InsuranceHomePage/InsurancePolicyDetail/SimulateFamilyMembersModal/SimulateFamilyMembersList/SimulateFamilyMemberCard/SimulateFamilyMemberCard';
import { TMemberSimulation } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export const SimulateFamilyMembersList = ({
  simulatedPersons,
  onToggle,
  onRemove,
  isLoading,
}: TSimulateFamilyMembersListProps) => {
  return (
    <Stack gap="md">
      <CardActionGroup>
        {simulatedPersons?.map((person, index) => (
          <SimulateFamilyMemberCard
            key={index}
            person={person}
            onToggle={() => onToggle(index)}
            onRemove={() => onRemove(index)}
            isLoading={isLoading}
          />
        ))}
      </CardActionGroup>
    </Stack>
  );
};

export type TSimulateFamilyMembersListProps = {
  simulatedPersons?: TMemberSimulation[];
  onToggle: (person: number) => void;
  onRemove: (index: number) => void;
  isLoading?: boolean;
};
